/**
 * Objektklassifizierung actions.
 * @module actions/objectklassifizierung/objectklassifizierung
 */

import { merge } from "lodash";

import { GET_OBJEKTKLASSIFIZIERUNG } from "../../constants/ActionTypes";
import { parseParams } from "../../helpers/url/url";
import { parsePrependParams } from "../../helpers/Api/ParsePrependParams";

/**
 * Get objectklassifizierung.
 * @function getObjektklassifizierung
 * @params {Number} id Id of the project.
 * @params {Number} bucket Bucket of the project.
 * @params {Object} filters Object with filters.
 * @returns {Object} Get objektklassifizierung action.
 */
export function getObjektklassifizierung(
  id,
  bucket,
  filters,
  scales,
  units,
  typeDashboard
) {
  return {
    type: GET_OBJEKTKLASSIFIZIERUNG,
    request: {
      op: "get",
      path: `objektklassifizierung/${id}`,
      params: merge(
        parseParams(filters),
        parsePrependParams(scales, "scale_"),
        parsePrependParams(units, "unit_"),
        bucket ? { bucket } : {},
        { typeDashboard: typeDashboard }
      )
    }
  };
}
